module.exports = __webpack_public_path__ + "img/kehu3.aec1877d.jpg";